<template>
  <div class="all">
    <!-- <div class="header">吾医空间隐私政策</div> -->
    <!-- <div class="container">
      <p>版本更新日期：【2022年3月31日】</p>
      <p>版本生效日期：【2022年3月31日】</p>
      <p>上一版本日期：【2021年9月26日】</p>
      <p>感谢您信赖武田中国！</p>
      <p>您及您的隐私对于我们至关重要，我们非常重视您的隐私和个人信息的保护。</p>
      <p>请您务必仔细阅读本隐私政策，在确认充分了解并同意后使用本平台的服务。</p>

      <p class="title"> 一、	本隐私政策的适用范围</p>
      <p>本隐私政策适用于您通过任何方式使用本平台提供的全部功能和/或服务（以下合称为“本平台服务”）而收集或存储的信息。我们希望通过本隐私政策向您说明在您使用本平台服务时，我们是如何收集、存储、使用、加工、传输、提供、公开、删除这些信息，以及我们将为您提供查阅、更正、限制、拒绝、删除、注销这些信息的方式。</p>
      <p>请您在继续使用本平台服务前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点，并确认您已经充分理解本隐私政策所写明的内容。重点内容及我们所收集您的个人信息具体类型我们均用粗体特别提示，希望您在阅读浏览时特别关注。经您点击同意，，即表示您同意本隐私政策的全部内容，表示您同意我们按照本隐私政策收集、存储、使用、加工、传输、提供、公开、删除您的相关信息。需要特别说明的是，除明确约定外，本政策不适用于其他第三方向您提供服务和/或功能的情形。</p>
      <p>如您对本隐私政策或相关事宜有任何疑问，可通过本隐私政策「第十二章节、如何联系我们」等方式与我们联系。</p>


      <p class="title">二、	本隐私政策将帮您了解的内容</p>
      <p class="indent1">(一)	我们如何收集和使用您的个人信息 </p>
      <p class="indent1">(二)	我们基于何种目的或场景，收集和使用您的个人信息 </p>
      <p class="indent1">(三)	我们如何使用Cookie等同类技术 </p>
      <p class="indent1">(四)	我们如何共享、转让与公开您的个人信息 </p>
      <p class="indent1">(五)	我们如何存储、保护您的个人信息</p>
      <p class="indent1">(六)	您查阅、更正、限制、拒绝、删除、注销个人信息的权利</p>
      <p class="indent1">(七)	未成年人保护</p>
      <p class="indent1">(八)	本隐私政策变更及通知</p>
      <p class="indent1">(九)	其他</p>
      <p class="indent1">(十)	如何联系我们</p>
      <p class="indent1">(十一)	定义与名词解释</p>

      <p class="title">三、	我们如何收集和使用您的个人信息</p>
      <p class="indent1">(一)	我们会根据本隐私政策的约定，为实现本平台服务而对所收集的个人信息进行使用。</p>
      <p class="indent1">(二)	我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：合法、正当、必要和诚信原则，目的明确和直接相关原则，公开透明原则、准确性原则、问责性原则、数据安全原则等。同时，我们承诺将按业界成熟的安全标准，采取必要的措施保障您的个人信息的安全。</p>
      

      <p class="title">四、	我们出于以下目的或基于如下场景，收集和使用您的个人信息</p>
      <p>出于本隐私政策所描述的目的或场景，当您使用本平台服务时，我们可能会收集有关您的如下个人信息。若您不同意提供下列信息，有权拒绝提供或撤回同意，但您可能无法继续使用本平台的全部或部分服务： </p>
      <p class="indent1">(一)	注册、登录</p>
      <p class="indent1-1">1.	为接受本平台全部服务，您首先需要注册本平台账号，为注册本平台账号，您需要提供以下信息，您可以在【便捷服务】-【个人中心】，更正您的姓名、医院（工作单位）和/或科室：</p>
      <p class="indent1-1-1">(1)	如果您是医疗卫生专业人士，您需要提供您的姓名、医院（工作单位）、科室、您所在的省份、城市、OPENID微信头像；</p>
      <p class="indent1-1-1">(2)	如果您是武田中国员工，您需要提供您的员工电子邮箱、邮箱登录密码、OPENID、微信头像。</p>
      <p class="indent1-1">2.	同时，本平台服务仅向医疗卫生专业人士或武田中国员工提供，因此需要验证您的医疗卫生专业人士或武田中国员工身份，若您不提供此类信息，因无法验证身份，您将无法使用本平台服务。</p>
      <p class="indent1-1">3.	若您为医疗卫生专业人士，您的成功注册为本平台用户后，当您使用本平台的【指尖视讯】项下【中文文献】或【国际期刊】获取文献原文时，我们收集、使用您的电子邮箱用于接收上述文献。如果您拒绝提供上述信息，将不会影响使用本平台基本服务。</p>
      <p class="indent1-1">4.	若您为医疗卫生专业人士，在您成功注册为本平台用户后，您可以在【便捷服务】-【个人中心】中补充您的感兴趣的领域、感兴趣的适应症，该等信息并非注册阶段所必需的信息。若您拒绝提供上述信息的，不影响您使用本平台的基本功能。</p>
      <p class="indent1">(二)	向您提供本平台服务</p>
      <p class="indent1-1">1.	信息展示、信息获取以及信息搜索浏览功能</p>
      <p class="indent1-1-1">(1)	在您使用本平台【指尖视讯】项下的【中文文献】或【国际期刊】时，可以根据个人需求选择搜索服务，通过搜索关键词精准定位内容。为了提供该等个性化搜索服务与内容的精准搜索服务、优化搜索服务以及依法留存网络服务日志，我们将可能收集您的日志信息作为网络日志保存，包括您点击的链接、输入的搜索关键词、访问服务的日期/时间、访问时长。</p>
      <p class="indent1-1-1">(2)	在您使用本平台【指尖视讯】项下的【中文文献】或【国际期刊】时，您可以根据您的个人需求选择下载文献。当您使用上述功能时，我们需要收集、使用您的电子邮箱用于接收上述文献；同时，在您阅读、搜索、收藏、获取文献时，我们会收集、使用您点击的链接、输入的关键词、访问服务的日期/时间，用于优化和改进本平台功能，提升您的用户体验，了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。</p>
      <p class="indent1-1-1">(3)	当您使用本平台【指尖视讯】项下的【文章集锦】或【视频学院】，【武田医学】下的【消化领域】、【肿瘤领域】、【血液制品】和/或【罕见病领域】，或【便捷服务】项下的【myPKFiT】时，我们会收集您点击的链接、访问服务的日期/时间、访问时长，用于优化和改进本平台功能，提升您的用户体验，了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。</p>
      <p class="indent1-1-1">(4)	当您使用【指尖视讯】项下【武田直播】功能，受邀参与相关会议/活动或观看相关会议/活动录播时，我们需要收集您的IP地址、点击的链接访问服务的日期/时间、访问时长，调研结果（如该会议/活动设置调研功能），用于优化本平台服务体验，提升您的用户体验，了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。</p>
      <p>请您注意：单独的个人常用设备信息、点击浏览信息无法单独识别您的身份，不属于您的个人信息；我们可能会将您的个人常用设备信息、点击浏览信息与您的其他信息相互关联并可以识别个人，在关联使用期间，我们会将该等信息作为您的个人信息，按照本隐私政策对其进行处理。</p>
      <p class="indent1-1">2.	个性化信息推荐</p>
      <p>当您使用本平台的个性化信息推荐服务时，我们会使用您的科室、OPENID，向您提供与您所感兴趣的学术信息、会议报道、研究进展、医学科学文献、行业资讯、公司资讯等。您可以通过不再关注本平台公众号的方式拒绝接收上述个性化信息推荐，但您拒绝后，我们将无法向您提供符合您专业领域的个性化信息推荐，但不影响您使用本平台的其他服务。</p>
      <p class="indent1-1">3.	医学信息咨询</p>
      <p>当您通过本平台【武田医学】项下【医学咨询】服务向我们发起医学信息咨询，为了方便与您主动联系或帮助您解决问题，我们可能需要收集并使用您的姓名、工作单位（医院）、科室、电子邮箱个人信息。如您拒绝提供上述信息，我们可能无法基于您的学术领域作出贴合您需求的回复；如您拒绝提供电子邮件，我们可能无法向您反馈医学信息咨询结果。</p>
      <p class="indent1-1">4.	受邀参加会议和活动</p>
      <p>当您受邀参加相关会议或活动，并使用【指尖视讯】项下的【武田直播】的直播功能时，我们需要使用您的OPENID，用于我们识别您作为参会人员时的有关参会、会议签到信息，验证会议或活动的真实性和有效性。</p>     
      <p class="indent1">(三)	处理投诉建议</p>
      <p>当您向本平台提起投诉、申诉，提供建议时，为了方便与您联系或帮助您解决问题，我们可能需要您提供姓名、医院（工作单位）、科室、电话号码、电子邮箱等个人信息。如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或建议结果。</p>
      <p class="indent1">(四)	需征得您同意的例外情形</p>
      <p>您知悉并理解，在以下情形下，本平台共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
      <p class="indent1-1">1.	根据您的需求订立、履行您作为一方当事人的合同所必需；</p>
      <p class="indent1-1">2.	为履行法定职责或法定义务所必需；</p>
      <p class="indent1-1">3.	为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
      <p class="indent1-1">4.	为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
      <p class="indent1-1">5.	依据法律法规规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；以及</p>
      <p class="indent1-1">6.	法律法规规定的其他情形。</p>
      <p class="indent1">(五)	如果您对我们收集和使用您的个人信息的法律依据有任何疑问或需要提供进一步的信息，请通过本隐私政策第十二章节「如何联系我们」提供的联系方式与我们联系。</p>
      <p class="indent1">(六)	当我们要将您的个人信息用于本隐私政策未载明的其他目的时，会事先征求您的同意。请您知悉，本平台向您提供的服务可能将不断更新和发展，如果您选择使用本隐私政策中尚未列明的其他功能或服务时，我们会在收集您的个人信息前通过推送通知、更为显著的弹窗等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。</p>


      <p class="title">五、	我们如何使用Cookie等同类技术</p>
      <p>Cookie、设备信息标识、像素标签、网站信标和脚本等同类技术是互联网中普遍使用的技术。当您使用本平台服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识您访问、使用本平台时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</p>
      <p class="indent1">(一)	保障平台运营、安全运转</p>
      <p>我们可能会设置认证与保障安全性的Cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈或其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
      <p class="indent1">(二)	帮助您获得更轻松的访问体验</p>
      <p>使用Cookie和同类技术可以帮助您省去重复填写个人信息实现自动登录、省去输入搜索内容的步骤和流程，例如记录搜索、表单填写。</p>
      <p class="indent1">(三)	了解服务偏好、实现个性化信息推荐</p>
      <p class="indent1-1">1.	我们可能会利用Cookie和同类技术了解您的偏好和使用习惯，进行数据分析以改善我们的服务、向您推荐个性化信息。</p>
      <p class="indent1-1">2.	我们可能会使用Cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。</p>
      <p>大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie等同类技术的服务。</p>

      <p class="title">六、	我们如何共享、转让与公开您的个人信息</p>
      <p class="indent1">(一)	共享</p>
      <p class="indent1-1">1.	我们承诺不会与武田中国及其关联公司以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
      <p class="indent1-1-1">(1)	在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息，但法律法规另有规定的除外。</p>
      <p class="indent1-1-1">(2)	我们可能会根据法律法规规定，或按照主管政府部门的强制性要求，对外共享您的个人信息。</p>
      <p class="indent1-1-1">(3)	只有共享您的信息，才能实现我们的功能与/或服务或提供您需要的服务，在该种情形下。</p>
      <p class="indent1-1-1">(4)	与我们的关联公司共享：您的个人信息可能会与武田中国的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所载明的目的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
      <p class="indent1-1-1">(5)	应您需求为您处理您与他人的纠纷或争议。</p>
      <p class="indent1-1-1">(6)	在法律法规允许的范围内，为维护武田中国及其关联方或合作伙伴、您或本平台其他用户利益或社会公众利益、财产或安全免遭损害而有必要提供。</p>
      <p class="indent1-1">2.	共享原则</p>
      <p class="indent1-1">我们承诺，仅在遵循以下原则的前提下共享您的信息：</p>
      <p class="indent1-1-1">(1)	授权同意原则：</p>
      <p class="indent1-1-1">未经您的同意，我们不会共享您的个人信息，除非是匿名化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第三方处理信息的目的、处理方式等超越原授权同意范围，第三方需要重新征得您的同意。</p>
      <p class="indent1-1-1">(2)	合法正当与最小必要原则：</p>
      <p class="indent1-1-1">共享信息必须具有合法正当目的，且共享的信息以达成目的必要为限。</p>
      <p class="indent1-1-1">(3)	安全审慎原则：</p>
      <p class="indent1-1-1">我们将审慎评估第三方使用共享信息的目的，并对第三方的安全保障能力进行综合评估，并要求其遵循委托协议、合作协议或其他授权处理协议；我们会对合作方获取信息的软件工具开发包（SDK，如有）、应用程序接口（API，如有）进行严格的安全监测，以保护信息安全。</p>
      <p class="indent1-1">3.	与我们合作的第三方类型</p>
      <p class="indent1-1">就本平台的某项服务或功能，我们可能委托第三方合作伙伴、服务提供商、供应商或分包商处理您的个人信息。对我们委托处理个人信息的第三方，我们会与其签署保密协议，要求其按照约定、本隐私政策以及法律法规要求的保密和安全措施处理个人信息。该等第三方合作伙伴、服务提供商、供应商或分包商主要包括：</p>
      <p class="indent1-1-1">(1)	系统服务、分析服务类供应商</p>
      <p class="indent1-1-1">我们可能将您的OPENID提供给供应商北京奇点万象科技有限公司、北京万方数据股份有限公司用于向您提供【国际期刊】及【中文文献】项下的摘要展示、浏览、原文下载服务，并向我们提供数据统计服务。</p>
      <p class="indent1-1-1">(2)	线上会议平台供应商</p>
      <p class="indent1-1-1">我们可能会将您的OPENID提供给上海翼得营销策划有限公司、北京瞬视天成科技有限公司，用于提供相关会议/活动的直播、录播观看、会议调研服务（如该会议/活动设置调研功能），并向我们提供数据统计服务。</p>
      <p class="indent1">我们合作的第三方列表</p>
      <div><img src="../../assets/agreeBook-table.png" alt=""></div>
      <p class="indent1">(二)	公开披露</p>
      <p class="indent1-1">我们仅会在以下情况下，公开披露您的个人信息:</p>
      <p class="indent1-1">1.	获得您明确同意后;</p>
      <p class="indent1-1">2.	基于法律的披露：在法律、法律程序、诉讼或主管政府部门强制性要求的情况；</p>
      <p class="indent1-1">3.	在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。</p>
      <p class="indent1">(三)	需要获取您的同意共享、转移、公开披露个人信息的例外情形：</p>
      <p class="indent1-1">尽管有上述约定，您知悉并理解，在以下情形下，本平台共享、转移、公开披露您的个人信息无需事先征得您的授权同意：</p>
      <p class="indent1-1">1.	根据您的需求订立、履行您作为一方当事人的合同所必需的；</p>
      <p class="indent1-1">2.	为履行法定职责或法定义务所必需；</p>
      <p class="indent1-1">3.	为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
      <p class="indent1-1">4.	为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
      <p class="indent1-1">5.	依据法律法规规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；以及</p>
      <p class="indent1-1">6.	法律法规规定的其他情形。</p>
      <p>根据法律规定，共享、转移、公开披露经匿名化处理的个人信息，且确保信息接收方无法复原且无法识别特定自然人的，不属于个人信息的共享、转移及公开披露行为，对此类信息的处理将无需另行向您通知并征得您的知情同意。</p>

      <p class="title">七、	我们如何保存、保护您的个人信息</p>
      <p class="indent1">(一)	个人信息的保存</p>
      <p class="indent1-1">1.	保存地点</p>
      <p class="indent1-1-1">武田中国按照法律法规规定，将在中国境内收集和产生的个人信息存储于中国境内。</p>
      <p class="indent1-1">2.	保存时间</p>
      <p class="indent1-1-1">请您注意，在您使用本平台服务时所提供的所有个人信息，除非（1）需要您单独授权；（2）您要求删除；（3）通过系统设置撤回同意拒绝我们收集；和/或（4）我们的正当业务需求使用您的个人信息，我们将在您使用本平台服务期间持续授权我们使用。在您申请注销账号同时，我们将对您的个人信息删除或匿名化处理，但法律法规另有规定的除外。</p>
      <p class="indent1">(二)	个人信息的保护</p>
      <p class="indent1-1">1.	保护措施</p>
      <p class="indent1-1-1">(1)	我们非常重视个人信息安全，我们决不会将您的个人信息恶意出售给任何第三方且会采取一切符合行业标准和惯例等一切合理可行的措施保护您的个人信息。</p>
      <p class="indent1-1-1">(2)	我们将采取适当的物理、管理和技术保护措施，包括加密技术、匿名化处理等手段，对您的个人信息进行存储，旨在保护我们收集和存储的个人信息的机密性、完整性和安全性，以防止意外或丢失、盗窃和滥用以及未经授权的访问、披露、更改销毁或任何其他类型的非法处理。</p>
      <p class="indent1-1-1">(3)	我们建立了完善的信息安全管理制度，并要求接触个人信息的员工签订相应的保密协议。</p>
      <p class="indent1-1">2.	安全事件处置</p>
      <p class="indent1-1-1">(1)	如发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们会及时将事件相关情况以平台通知、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。</p>
      <p class="indent1-1-1">(2)	我们会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。使用防火墙、云加密保护措施。在发生危害网络安全的事件时，我们会按照网络安全事件应急预案，及时采取相应的补救措施。</p>
      <p class="indent1-1-1">(3)	本平台还将按照监管部门的要求，主动上报个人信息安全事件的处置情况。</p>
      <p>您理解并知悉，本平台将尽力确保您的个人信息的安全，但互联网并非绝对安全的环境，本平台无法确保您的个人信息的绝对安全，若发生不可抗力（包括但不限于网络故障、病毒、黑客攻击等）并产生损失时，本平台不承担任何责任。</p>
      <p class="indent1-1">3.	除个人信息以外的其他信息与数据</p>
      <p class="indent1-1-1">请您注意，除了上述已列明的您的个人信息外，所有您通过本平台提供的任何形式的信息或者数据，包括文件、数据、图像、问题、建议、概念、备注或其他数据，均不会被视为保密信息。因此您传送或者分享该等信息或数据即代表您赋予我们使用、复制、传播、修改、处理、存储该等信息或者数据之权利，或传送有关信息或数据以处理您后续的相关要求。</p>


      <p class="title">八、	您查阅、更正、限制、拒绝、删除、注销个人信息的权利</p>
      <p>我们非常重视并保护您对于个人信息处理活动中的知情权、决定权、限制权、拒绝权等权利，并为您提供了行使在个人信息处理活动中相关权利的方法。</p>
      <p class="indent1">(一)	查阅权和更正权</p>
      <p class="indent1-1">除法律法规规定的情形除外，您有权随时查阅和更正您的个人信息，具体包括：</p>
      <p class="indent1-1">1.	您可以通过在本平台的【便捷服务】-【个人中心】查阅或更正您的姓名、医院（工作单位）、科室、所在省份、城市；</p>
      <p class="indent1-1">2.	当您需要查阅或更正您的个人信息，或通过反馈与报错等将您的更正申请提交给我们。在您进行查阅或更正前，我们会在合理要求下并经验证核实您的身份后，再处理您的请求。</p>
      <p class="indent1">(一)	限制或拒绝权</p>
      <p class="indent1-1">对于您个人信息的收集和使用，您可以在本平台上随时通过以下方式撤回授权同意，以限制或拒绝我们收集或使用您的个人信息：</p>
      <p class="indent1-1">1.	您可通过不再关注本平台停止接收本平台的信息推荐。当您停止接收本平台个性化信息推荐服务后，我们将不再向您推荐您所感兴趣的的学术信息、会议报道、研究进展、医学科学文献、行业资讯、公司资讯等个性化信息；当您撤回同意后，我们将不再继续为您提供撤回同意所对应的服务，并且不再处理相应的个人信息，但请您理解，您撤回同意的决定，不影响撤回前基于您的同意已进行的个人信息处理活动的效力。</p>
      <p class="indent1-1">2.	对于我们根据信息系统、算法在内的非人工自动决策机制，并基于您的诊疗科目（科室）所作的个性化信息推荐，您可以通过【便捷服务】-【个人中心】修改科室的方式获取不针对您个人特征推送的内容和信息。如果该等基于自动化决策推送的内容严重影响您的合法权益的，您有权根据法律法规规定要求我们作出说明。</p>
      <p class="indent1-1">3.	您可通过【便捷服务】-【个人中心】中删除您的姓名、医院（工作单位）、科室，您也可以通过注销账号的形式撤回我们对您个人信息处理全部同意或通过「第十二章节、如何联系我们」进行相应的同意变更。请您谨慎操作，否则，因注销账号产生的数据丢失问题均由您自行承担。在注销账号之后，我们将停止为您提供本平台服务，并依据您的要求，删除您的个人信息，但法律法规另有规定的除外。	</p>
      <p class="indent1">(二)	删除权</p>
      <p class="indent1-1">1.	您可通过微信的缓存清理功能，删除您在本平台的缓存记录提供的相关个人信息。</p>
      <p class="indent1-1">2.	如果您需要删除您在使用本平台过程中产生的其他个人信息，在您的合理要求并经验证核实您的身份后，我们会处理您的请求。您可以通过本隐私政策「第十二章节、如何联系我们」方式向我们进行反馈。</p>
      <p class="indent1-1">3.	在以下情形中，您可以向我们提出删除个人信息的请求：</p>
      <p class="indent1-1-1">(1)	我们永久不再为您提供产品或服务；</p>
      <p class="indent1-1-1">(2)	您撤回对我们收集、使用您的个人信息的同意；</p>
      <p class="indent1-1-1">(3)	我们处理个人信息的行为违反法律、行政法规；</p>
      <p class="indent1-1-1">(4)	我们处理个人信息的行为违反了与您的约定；</p>
      <p class="indent1-1-1">(5)	您注销了用户帐号；</p>
      <p class="indent1-1-1">(6)	法律、行政法规规定的其他情形。</p>
      <p class="indent1-1">4.	您同意并理解，您删除某些您已提交的个人信息可能导致您无法使用本平台的部分或者全部服务。</p>
      <p class="indent1">(三)	注销权</p>
      <p class="indent1-1">您可以通过本平台【便捷服务】-【个人中心】项下进行注销操作。一旦您注销账户，我们将停止为您提供服务。请您谨慎操作，否则，因注销账号产生的数据丢失问题均由您自行承担。当您选择注销账户后，我们将停止为您提供服务，并依据您的要求，删除您的个人信息，但法律法规另有规定的除外。</p>
      <p class="indent1">(四)	豁免适用的例外</p>
      <p class="indent1-1">按照中国法律法规要求，以下情况中，我们将无法满足您关于处理个人信息的请求：</p>
      <p class="indent1-1">1.	根据您的需求订立、履行您作为一方当事人的合同所必需的；</p>
      <p class="indent1-1">2.	为履行法定职责或法定义务所必需；</p>
      <p class="indent1-1">3.	为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
      <p class="indent1-1">4.	为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理您的个人信息；</p>
      <p class="indent1-1">5.	依据法律法规规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；以及</p>
      <p class="indent1-1">6.	法律法规规定的其他情形。</p>

      <p class="title">九、	未成年人保护</p>
      <p>我们非常重视对未成年人个人信息的保护，本平台的注册用户仅包括供医疗卫生专业人士。不涉及18周岁以下的未成年人注册为本平台账户。若您是未成年人，不得予以注册。</p>
      
      <p class="title">十、	本隐私政策变更及通知</p>
      <p class="indent1">(一)	为了向您提供更好的功能与/或服务，我们的功能与/或服务将不时更新与变化，因此，我们将适时修订及变更隐私政策。</p>
      <p class="indent1">(二)	未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
      <p class="indent1">(三)	对于重大变更，我们可能还会提供本平台公告、推送通知或更为显著的弹窗等方式，向您发送隐私政策的最新版本。本政策重大变更包括但不限于：</p>
      <p class="indent1-1">1.	我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
      <p class="indent1-1">2.	我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
      <p class="indent1-1">3.	个人信息共享、转让或公开披露的主要对象发生变化；</p>
      <p class="indent1-1">4.	您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
      <p class="indent1-1">5.	我们的联络方式及投诉渠道发生变化；</p>
      <p class="indent1-1">6.	个人信息安全影响评估报告表明存在高风险时。</p>

      <p class="title">十一、	其他</p>
      <p> 本平台可能不时提供各种链接，最终可以跳转或指向非为武田中国所持有或控制的第三方网站或应用程序。本隐私政策不适用于此等网站或应用程序。若您选择跳转及使用此等网站或应用程序，请务必查看您所登入的网站或应用程序的隐私政策或隐私声明，谨慎选择是否同意并继续。本隐私政策不能引伸或适用于与本平台连结或相联的任何其他第三方网站或者平台。 </p>
      <p>我们提醒您，一旦您离开本平台，浏览或使用其他网站、服务及内容资源，本平台即没有能力及义务保护您在本平台之外的网站或应用程序提交的任何个人信息，无论您登录或浏览上述网站或应用程序是否基于本平台中所包含的链接或引导，本平台对此不承担任何法律责任。</p>

      <p class="title">十二、	如何联系我们</p>
      <p> 如需更多关于武田隐私保护的政策，请访问：https://www.takeda.com/privacy-notice/ </p>
      <p>如涉及隐私问题，可以联系 PrivacyOffice@takeda.com</p>

      <p class="title">十三、	定义与名词解释</p>
      <p> 本平台：由武田中国享有所有权和运营的账号为gh_2d053a85aa0c的微信公众号，该等微信公众号名称为“吾医空间”。 </p>
      <p>武田中国、我们：直接或委托第三方提供本平台和相关服务的法律实体，包括武田（中国）投资有限公司、武田（中国）国际贸易有限公司、武田药品（中国）有限公司、天津武田药品有限公司一家或多家。</p>
      <p>关联公司：与武田中国存在关联关系的法律实体。“关联关系”是指对于任何主体（包括个人、公司、合伙企业、组织或其他任何实体）而言，即其直接或间接控制的主体，或直接或间接控制其的主体，或直接或间接与其受同一主体控制的主体。前述“控制”指，通过持有表决权、合约或其他方式，直接或间接地拥有对相关主体的管理和决策作出指示或责成他人作出指示的权力或事实上构成实际控制的其他关系。</p>
      <p>中国：指中华人民共和国，为本隐私政策之目的，不包括香港特别行政区、澳门特别行政区和台湾地区。</p>
      <p>个人信息：以电子或者其他方式记录的与已识别或可识别的自然人有关的各种信息，不包括匿名化处理后的信息。如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。</p>
      <p>去标识化：指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</p>
      <p>匿名化：指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
      <p>敏感个人信息：敏感个人信息是指一旦泄露或者非法使用，容易导致自然人的人格尊严收到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。</p>
      <p>IP地址：每台上网的设备都会指定一个编号，称为互联网协议(IP)地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。</p>
      <p>OPENID:OPENID是微信用户在注册公众号后的唯一独立加密用户身份标识，此处OPENID是指吾医空间公众号下用户注册后的唯一加密用户身份标识。</p>
    </div> -->
    <div class="view">
      <p style="text-align: center">吾医空间隐私政策</p>
      <p style="text-align: center">&nbsp;</p>
      <p>版本更新日期：2022年12月14日</p>
      <p>版本生效日期：2023年3月25日</p>
      <p>上一版本日期：2022年3月31日</p>
      <p>&nbsp;</p>
      <p>
        感谢您信赖武田（中国）投资有限公司及其关联公司武田（中国）国际贸易有限公司、武田药品（中国）有限公司、天津武田药品有限公司（联系方式：<a
          href="mailto:PrivacyOffice@takeda.com"
          style="color: #0000ee"
          >PrivacyOffice@takeda.com</a
        >，下称“<strong>武田中国</strong>”或“<strong>我们</strong>”）！
      </p>
      <p>&nbsp;</p>
      <p>
        您及您的隐私对于我们至关重要，我们非常重视您的隐私和个人信息的保护。
      </p>
      <p>&nbsp;</p>
      <p>
        请您务必仔细阅读本隐私政策，在确认<strong
          ><span style="text-decoration: underline"
            >充分了解并同意后</span
          ></strong
        >使用本平台的服务。
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph">
        <strong><span style="color: #1f3864">一、</span></strong
        ><strong
          ><span style="color: #1f3864">本隐私政策的适用范围</span></strong
        >
      </p>
      <p>
        本隐私政策适用于您通过任何方式使用本平台提供的全部功能和/或服务（以下合称为“<strong>本平台服务</strong>”）而收集或存储的信息。我们希望通过本隐私政策向您说明在您使用本平台服务时，我们是如何<strong>收集、存储、使用、加工、传输、提供、公开、删除</strong>这些信息，以及我们将为您提供<strong>查阅、更正、限制、拒绝、删除、注销</strong>这些信息的方式。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong
          >请您在继续使用本平台服务前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点，并确认您已经充分理解本隐私政策所写明的内容。重点内容及我们所收集您的个人信息具体类型我们均用粗体特别提示，希望您在阅读浏览时特别关注。经您点击同意，即表示您同意本隐私政策的全部内容，表示您同意我们按照本隐私政策收集、存储、使用、加工、传输、提供、公开、删除您的相关信息。需要特别说明的是，除明确约定外，本政策不适用于其他第三方向您提供服务和/或功能的情形。</strong
        >
      </p>
      <p><strong>&nbsp;</strong></p>
      <p>
        <strong>如您对本隐私政策或相关事宜有任何疑问，可通过本隐私政策</strong
        ><span style="color: black">「</span
        ><strong>第十二章节、如何联系我们</strong
        ><span style="color: black">」</span><strong>等方式与我们联系。</strong>
      </p>
      <p><strong>&nbsp;</strong></p>
      <p class="MsoListParagraph">
        <strong><span style="color: #1f3864">二、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >本隐私政策将帮您了解的内容</span
          ></strong
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >我们如何收集和使用您的个人信息
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >我们基于何种目的或场景，收集和使用您的个人信息
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >我们如何使用Cookie等同类技术
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >我们如何共享、公开与委托处理您的个人信息
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >我们如何保存、保护您的个人信息
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >您查阅、更正、限制、拒绝、删除、注销个人信息的权利
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >未成年人保护
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >本隐私政策变更及通知
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >其他
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >如何联系我们
      </p>
      <p class="MsoListParagraph" style="">
        <span style="font-family: Wingdings"
          >•<span style="font: 9px 'Times New Roman'">&nbsp;&nbsp; </span></span
        >定义与名词解释
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">三、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >我们如何收集和使用您的个人信息</span
          ></strong
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="display: flex">
        (一)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们会根据本隐私政策的约定，为实现本平台服务而对所收集的个人信息进行使用。
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">&nbsp;</p>
      <p class="MsoListParagraph" style="display: flex">
        <span>(二)</span>
        <span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span>
          我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。<strong>我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：合法、正当、必要和诚信原则，目的明确和直接相关原则，公开透明原则、准确性原则、问责性原则、数据安全原则等。</strong>同时，我们承诺将按业界成熟的安全标准，采取必要的措施保障您的个人信息的安全。
        </span>
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">四、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >我们出于以下目的或基于如下场景，收集和使用您的个人信息</span
          ></strong
        >
      </p>
      <p>&nbsp;</p>
      <p>
        出于本隐私政策所描述的目的或场景，当您使用本平台服务时，我们可能会收集有关您的如下个人信息。若您不同意提供下列信息，有权拒绝提供或撤回同意，但您可能无法继续使用本平台的全部或部分服务：
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          >(一)<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>注册、登录</strong>
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <strong>&nbsp;</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        1.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          >为接受本平台全部服务，您首先需要注册本平台账号。为注册本平台账号，您需要提供以下信息，您后续可以在<strong>【便捷服务】-【个人中心】</strong>，更正您的<strong>姓名、医院（工作单位）</strong>和/或<strong>科室</strong>：
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (1)<span>&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          >如果您是医疗卫生专业人士，您需要提供您的<strong>姓名、医院（工作单位）、科室、所在省份、城市、OPENID、微信头像</strong>；
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (2)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span>
          如果您是武田中国员工，您需要提供您的<strong>员工电子邮箱、邮箱登录密码、OPENID、微信头像</strong>。
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        2.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >同时，本平台服务仅向医疗卫生专业人士或武田中国员工提供，因此需要验证您的医疗卫生专业人士或武田中国员工身份，若您不提供上文第1段中的信息，因无法验证身份，您将无法使用本平台服务。
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        3.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span>
          若您为医疗卫生专业人士，您的成功注册为本平台用户后，当您使用本平台的<strong>【指尖视讯】</strong>项下<strong>【中文文献】</strong>或<strong>【国际期刊】</strong>获取文献原文时，我们将收集、使用您的<strong>电子邮箱</strong>用于接收上述文献。<strong
            >如果您拒绝提供上述信息，将不会影响使用本平台基本服务。</strong
          ></span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        4.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span>
          若您为医疗卫生专业人士，在您成功注册为本平台用户后，您可以在<strong>【便捷服务】-【个人中心】</strong>中补充您的<strong>感兴趣的领域、感兴趣的适应症</strong>，该等信息并非注册阶段所必需的信息。若您拒绝提供上述信息的，不影响您使用本平台的基本功能。
        </span>
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          >(二)<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>向您提供本平台服务</strong>
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <strong>&nbsp;</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px">
        <strong
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>信息展示、信息获取以及信息搜索浏览功能</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        (1)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span>
          在您使用本平台<strong>【指尖视讯】</strong>项下的<strong>【中文文献】</strong>或<strong>【国际期刊】</strong>时，可以根据个人需求选择搜索服务，通过搜索关键词精准定位内容。<strong
            >为了提供该等个性化搜索服务与内容的精准搜索服务、优化搜索服务以及依法留存网络服务日志，我们将可能收集您的日志信息作为网络日志保存，包括您点击的链接、输入的搜索关键词、访问服务的日期/时间、访问时长。</strong
          >
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        (2)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          >在您使用本平台<strong>【指尖视讯】</strong>项下的<strong>【中文文献】</strong>或<strong>【国际期刊】</strong>时，您可以根据您的个人需求选择下载文献。当您使用上述功能时，我们需要收集、使用您的<strong>电子邮箱</strong>用于接收上述文献；同时，在您阅读、搜索、收藏、获取文献时，我们会收集、使用您<strong>点击的链接、输入的关键词、访问服务的日期/时间</strong>，用于优化和改进本平台功能、提升您的用户体验、了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        (3)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          >当您使用本平台<strong>【指尖视讯】</strong>项下的<strong>【文章集锦】</strong>，<strong>【武田医学】</strong>下的<strong>【消化领域】、【肿瘤领域】、【血液制品】</strong>和/或<strong>【罕见病领域</strong>】，或<strong>【便捷服务】</strong>项下的<strong>【myPKFiT】</strong>时，我们会收集您<strong>点击的链接、访问服务的日期/时间、访问时长</strong>，用于优化和改进本平台功能、提升您的用户体验、了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        (4)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          >当您使用<strong>【指尖视讯】</strong>项下<strong>【武田直播】</strong>功能，受邀参与相关会议/活动或观看相关会议/活动录播时，我们需要收集您的<strong>IP地址、点击的链接访问服务的日期/时间、访问时长，调研结果（如该会议/活动设置调研功能），</strong>用于优化本平台服务体验、提升您的用户体验、了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        (5)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          >当您使用本平台<strong>【指尖视讯】</strong>项下的<strong>【用药助手】</strong>时，您将跳转至观澜网络（杭州）有限公司运营的数据库，观澜网络（杭州）有限公司将向我们分享您点击的链接、搜索的关键字、访问服务的日期/时间、访问时长。我们将对这些信息进行分析，用于优化和改进本平台功能、提升您的用户体验、了解您使用或接受服务的方式和偏好，以便进一步调整服务内容，更好地满足您的学术需求。
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        &nbsp;
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        <strong
          >请您注意：单独的个人常用设备信息、点击浏览信息无法单独识别您的身份，不属于您的个人信息；我们可能会将您的个人常用设备信息、点击浏览信息与您的其他信息相互关联并可以识别个人，在关联使用期间，我们会将该等信息作为您的个人信息，按照本隐私政策对其进行处理。</strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 66px; text-indent: 0">
        <strong>&nbsp;</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <strong
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>个性化信息推荐</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        当您使用本平台的个性化信息推荐服务时，我们会使用您的<strong>科室、OPENID</strong>，<strong>向您提供与您所感兴趣的学术信息、会议报道、研究进展、医学科学文献、行业资讯、公司资讯</strong>等。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        你可根据<strong>本隐私政策</strong><span style="color: black">「</span
        ><strong
          >第八章节、您查阅、更正、限制、拒绝、删除、注销个人信息的权利</strong
        ><span style="color: black">」</span
        ><strong>第（二）节第1条和第2条</strong
        >拒绝个性化信息推荐。您拒绝后，我们将无法向您提供符合您专业领域的个性化信息推荐，但不影响您使用本平台的其他服务。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        &nbsp;
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <strong
          >3.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>医学信息咨询</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        当您通过本平台<strong>【武田医学】</strong>项下<strong>【医学咨询】</strong>服务向我们发起医学信息咨询，为了方便与您主动联系或帮助您解决问题，我们可能需要收集并使用您的<strong>姓名、工作单位（医院）、科室、电子邮箱</strong>个人信息。如您拒绝提供<strong>上述信息，我们可能无法基于您的学术领域作出贴合您需求的回复；如您拒绝提供电子邮件，我们可能无法向您反馈医学信息咨询结果</strong>。
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        &nbsp;
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <strong
          >4.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>受邀参加会议和活动</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        当您受邀参加相关会议/活动，并使用<strong>【指尖视讯】</strong>项下的<strong>【武田直播】</strong>的直播功能时，我们需要使用您的<strong>OPENID</strong>，<strong>用于我们识别您作为参会人员时的有关参会、会议签到信息，验证会议/活动的真实性和有效性</strong>。
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        &nbsp;
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          >(三)<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>处理投诉建议</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        当您向本平台提起投诉、申诉，提供建议时，为了方便与您联系或帮助您解决问题，我们可能需要您提供<strong>姓名、医院（工作单位）、科室、电话号码、电子邮箱</strong>等个人信息。<strong>如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或建议结果</strong>。
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          >(四)<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>需征得您同意的例外情形</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        您知悉并理解，在以下情形下，本平台收集、使用、共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        1.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >根据您的需求订立、履行您作为一方当事人的合同所必需；
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        2.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >为履行法定义务所必需；
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        3.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        4.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        5.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >依据法律法规规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；以及
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        6.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >法律法规规定的其他情形。
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="display: flex">
        <strong
          ><span style="color: black"
            >(五)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong
          >如果您对我们收集和使用您的个人信息的法律依据有任何疑问或需要提供进一步的信息，请通过本隐私政策第十二章节「如何联系我们
          」提供的联系方式与我们联系</strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <span style="color: black">&nbsp;</span>
      </p>
      <p class="MsoListParagraph" style="display: flex">
        <strong
          ><span style="color: black"
            >(六)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong
          ><span style="color: black"
            >当我们要将您的个人信息用于本隐私政策未载明的其他目的时，会事先征求您的同意。请您知悉，本平台向您提供的服务可能将不断更新和发展，如果您选择使用本隐私政策中尚未列明的其他功能或服务时，我们会在收集您的个人信息前通过推送通知、更为显著的弹窗等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。</span
          ></strong
        ><span></span>
      </p>
      <p>
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">五、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >我们如何使用Cookie等同类技术</span
          ></strong
        >
      </p>
      <p>
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p>
        Cookie、设备信息标识、像素标签、网站信标和脚本等同类技术是互联网中普遍使用的技术。当您使用本平台服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识您访问、使用本平台时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：
      </p>
      <p>
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(一)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong
          ><span style="color: black">保障平台运营、安全运转</span></strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: black"
          >我们可能会设置认证与保障安全性的Cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈或其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</span
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(二)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong
          ><span style="color: black">帮助您获得更轻松的访问体验</span></strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: black"
          >使用Cookie和同类技术可以帮助您省去重复填写个人信息实现自动登录、省去输入搜索内容的步骤和流程，例如记录搜索、表单填写。</span
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(三)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong
          ><span style="color: black"
            >了解服务偏好、实现个性化信息推荐</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: black"
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: black"
          >我们可能会利用Cookie和同类技术了解您的偏好和使用习惯，进行数据分析以改善我们的服务、向您推荐个性化信息。</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: black"
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: black"
          >我们可能会使用Cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。</span
        >
      </p>
      <p>
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p>
        <strong
          >大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie等同类技术的服务。</strong
        >
      </p>
      <p style="vertical-align: baseline">
        <strong
          ><span
            style="font-size: 15px; font-family: 'Microsoft YaHei', sans-serif"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">六、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >我们如何共享、公开与委托处理您的个人信息</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(一)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">共享</span></strong>
      </p>
      <p style="margin-left: 32px">
        <strong
          >我们承诺不会与武田中国及其关联公司以外的任何公司、组织和个人共享您的个人信息，除非另行获得您的单独同意或者根据法律法规的规定进行共享。</strong
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(二)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">公开披露</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        我们仅会在以下情况下，公开披露您的个人信息:
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        1.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >获得您单独同意后;
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        2.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        >基于履行法定义务所必需的情况；在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <strong
          >根据法律规定，共享、公开披露经匿名化处理的个人信息，且确保信息接收方无法复原且无法识别特定自然人的，不属于个人信息的共享或公开披露行为，对此类信息的处理将无需另行向您通知并征得您的知情同意。</strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        &nbsp;
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(三)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">委托处理</span></strong>
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        就本平台的某项服务或功能，我们可能会委托第三方合作伙伴、服务提供商、供应商或分包商，根据我们的指示处理您的个人信息。我们会与受托人签署有关个人信息处理的委托协议，要求其按照协议约定、本隐私政策以及法律法规要求的保密和安全措施处理个人信息。该等第三方合作伙伴、服务提供商、供应商或分包商包括：
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        1.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          ><strong>系统服务、分析服务类供应商</strong
          >，其将向您提供<strong>【国际期刊】及【中文文献】</strong>项下的<strong>摘要展示、浏览、原文下载</strong>服务，并向我们提供数据统计服务。
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        2.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span
          ><strong>线上会议平台供应商</strong
          >，其将提供<strong>相关会议/活动的直播、录播观看、会议调研服务（如该会议/活动设置调研功能）</strong>，并向我们提供数据统计服务。
        </span>
      </p>
      <p><strong>&nbsp;</strong></p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">七、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >我们如何保存、保护您的个人信息</span
          ></strong
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(一)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">个人信息的保存</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px">
        <strong
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>保存地点</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        武田中国按照法律法规规定，将在中国境内收集和产生的个人信息存储于中国境内。
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px">
        <strong
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>保存时间</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        请您注意，在您使用本平台服务时所提供的所有个人信息，除非（1）我们另行获得您有关延长保存时间的授权，（2）您要求删除，和/或（3）您通过系统设置撤回同意拒绝我们收集，我们将仅在您使用本平台服务期间持续保存和使用您的个人信息。在您申请注销账号同时，我们将对您的个人信息删除或匿名化处理，但法律法规另有规定的除外。
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <span style="font-family: SimSun; color: #333333">&nbsp;</span>
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(二)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">个人信息的保护</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px">
        <strong
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>保护措施</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (1)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们非常重视个人信息安全，我们决不会将您的个人信息恶意出售给任何第三方且会采取一切符合行业标准和惯例等一切合理可行的措施保护您的个人信息。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (2)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们将采取适当的物理、管理和技术保护措施，包括加密技术、匿名化处理等手段，对您的个人信息进行存储，旨在保护我们收集和存储的个人信息的机密性、完整性和安全性，以防止意外或丢失、盗窃和滥用以及未经授权的访问、披露、更改销毁或任何其他类型的非法处理。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (3)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们建立了完善的信息安全管理制度，并要求接触个人信息的员工签订相应的保密协议。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        &nbsp;
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px">
        <strong
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>安全事件处置</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (1)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >如发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们会及时将事件相关情况以平台通知、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (2)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。使用防火墙、云加密保护措施。在发生危害网络安全的事件时，我们会按照网络安全事件应急预案，及时采取相应的补救措施。
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (3)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >本平台还将按照监管部门的要求，主动上报个人信息安全事件的处置情况。
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        <strong
          >您理解并知悉，本平台将尽力确保您的个人信息的安全，但互联网并非绝对安全的环境，本平台无法确保您的个人信息的绝对安全，若发生不可抗力（包括但不限于网络故障、病毒、黑客攻击等）并产生损失时，本平台不承担任何责任。</strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <strong>&nbsp;</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px">
        <strong
          >3.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></strong
        ><strong>除个人信息以外的其他信息与数据</strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; text-indent: 0">
        请您注意，除了上述已列明的您的个人信息外，您通过本平台提供的任何形式的信息或者数据，包括文件、数据、图像、问题、建议、概念、备注或其他数据，均不会被视为保密信息。因此，您传送或者分享该等信息或数据即代表您赋予我们使用、复制、传播、修改、处理、存储该等信息或者数据之权利，或传送有关信息或数据以处理您后续的相关要求。
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <strong>&nbsp;</strong>
      </p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">八、</span></strong
        ><strong
          ><span style="color: #1f3864"
            >您查阅、更正、限制、拒绝、删除、注销个人信息的权利</span
          ></strong
        >
      </p>
      <p>
        <strong><span style="color: black">&nbsp;</span></strong>
      </p>
      <p>
        我们非常重视并保护您对于个人信息处理活动中的知情权、决定权、限制权、拒绝权等权利，并为您提供了行使在个人信息处理活动中相关权利的方法。
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(一)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">查阅权和更正权</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        除法律<span style="color: black">法规</span
        >规定的情形除外，您有权随时查阅和更正您的个人信息，具体包括：
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span
          ><span style="color: #333333">您可以通过在</span>本平台的<strong
            >【便捷服务】-【个人中心】</strong
          ><span style="color: #333333"
            >查阅或更正您的<strong>姓名、医院（工作单位）、科室、所在省份、城市</strong>；</span
          >
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: #333333">&nbsp;</span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span
          ><span style="color: #333333"
            >您需要查阅或更正您的个人信息，或通过反馈与报错等将您的更正申请提交给我们。在您进行查阅或更正前，<strong>我们会在合理要求下并经验证核实您的身份后</strong>，再处理您的请求。</span
          >
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: #333333">&nbsp;</span>
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(二)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">限制或拒绝权</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        对于您个人信息的收集和使用，您可以在本平台上随时通过以下方式撤回授权同意，以限制或拒绝我们收集或使用您的个人信息：
      </p>
      <p><span style="color: #333333">&nbsp;</span></p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: #333333"
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >您可通过<strong>不再关注本平台</strong>停止接收本平台的个性化信息推荐。当您停止接收本平台个性化信息推荐服务后，我们将不再向您推荐您所感兴趣的的学术信息、会议报道、研究进展、医学科学文献、行业资讯、公司资讯等个性化信息。另外，当您撤回同意后，我们将不再继续为您提供撤回同意所对应的服务，并且不再处理相应的个人信息。但请您理解，您撤回同意的决定，不影响撤回前基于您的同意已进行的个人信息处理活动的效力。</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: #333333"
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >对于我们根据信息系统、算法在内的非人工自动决策机制，并基于您的诊疗科目（科室）所作的个性化信息推荐，您可以通过</span
        ><strong>【便捷服务】-【个人中心】</strong
        >删除科室的方式获取不针对您个人特征推送的内容和信息<strong
          >。如果该等基于自动化决策推送的内容严重影响您的合法权益的，您有权根据法律法规规定要求我们作出说明。</strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: #333333"
          >3.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >您可通过<strong>【便捷服务】-【个人中心】</strong>中删除您的<strong>姓名、医院（工作单位）、科室</strong>，您也可以通过<strong>注销账号</strong>的形式撤回我们对您个人信息处理全部同意或通过</span
        ><span style="color: black">「</span
        ><strong>第十二章节、如何联系我们</strong
        ><span style="color: black">」</span
        ><span style="color: #333333"
          >进行相应的同意撤回。请您谨慎操作，否则，因注销账号产生的数据丢失问题均由您自行承担。在注销账号之后，我们将停止为您提供本平台服务，并依据您的要求，删除您的个人信息，但法律法规另有规定的除外。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: black"
            >(三)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">删除权</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        1.<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
        ><span>
          您可通过<strong>微信的缓存清理功能，删除您在本平台的缓存记录</strong
          ><span style="color: #333333">提供的相关个人信息。</span>
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span
          ><span style="color: #333333"
            >如果您需要删除您在使用本平台过程中产生的其他个人信息，在您的合理要求并经验证核实您的身份后，我们会处理您的请求。您可以通过本隐私政策</span
          ><strong
            ><span style="color: black">「</span
            >第十二章节、如何联系我们</strong
          ><span style="color: black">」</span
          ><span style="color: #333333">方式向我们进行反馈。</span>
        </span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >3.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >在以下情形中，您可以向我们提出删除个人信息的请求：</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (1)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们永久不再为您提供产品或服务；
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (2)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >您撤回对我们收集、使用您的个人信息的同意；
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (3)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们处理个人信息的行为违反法律、行政法规；
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (4)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >我们处理个人信息的行为违反了与您的约定；
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (5)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >您注销了用户帐号；
      </p>
      <p class="MsoListParagraph" style="margin-left: 57px; display: flex">
        (6)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >法律、行政法规规定的其他情形。
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >4.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >您同意并理解，您删除某些您已提交的个人信息可能导致您无法使用本平台的部分或者全部服务。</span
        >
      </p>
      <p style="text-align: left; text-indent: 20px">
        <span style="font-family: SimSun; color: #333333">&nbsp;</span>
      </p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: #333333"
            >(四)<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: black">注销权</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; text-indent: 0">
        <span style="color: #333333"
          >您可以通过本平台<strong>【便捷服务】-【个人中心】项下进行注销操作</strong>。一旦您注销账户，我们将停止为您提供服务。请您谨慎操作，否则，因注销账号产生的数据丢失问题均由您自行承担。</span
        >当您选择注销账户后，我们将停止为您提供服务，<span
          style="color: #333333"
          >并依据您的要求，删除您的个人信息，但法律法规另有规定的除外。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 0">
        <span style="font-family: SimSun; color: #333333">&nbsp;</span>
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">九、</span></strong
        ><strong><span style="color: #1f3864">未成年人保护</span></strong>
      </p>
      <p>&nbsp;</p>
      <p>
        我们非常重视对未成年人个人信息的保护，本平台的注册用户仅包括供医疗卫生专业人士。不涉及18周岁以下的未成年人注册为本平台账户。若您是未成年人，不得予以注册。
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong><span style="color: #1f3864">十、</span></strong
        ><strong
          ><span style="color: #1f3864">本隐私政策变更及通知</span></strong
        >
      </p>
      <p class="MsoListParagraph" style="display: flex">
        (一)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >为了向您提供更好的功能与/或服务，我们的功能与/或服务将不时更新与变化，因此，我们将适时修订及变更隐私政策。
      </p>
      <p class="MsoListParagraph" style="display: flex">
        (二)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
      </p>
      <p class="MsoListParagraph" style="display: flex">
        (三)<span style="font: 9px 'Times New Roman'"
          >&nbsp;&nbsp;&nbsp;&nbsp; </span
        >对于重大变更，我们可能还会提供本平台公告、推送通知或更为显著的弹窗等方式，向您发送隐私政策的最新版本。本政策重大变更包括但不限于：
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >1.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >2.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >3.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >个人信息共享、转让或公开披露的主要对象发生变化；</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >4.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >5.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333">我们的联络方式及投诉渠道发生变化；</span>
      </p>
      <p class="MsoListParagraph" style="margin-left: 32px; display: flex">
        <span style="color: #333333"
          >6.<span style="font: 9px 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="color: #333333"
          >个人信息安全影响评估报告表明存在高风险时。</span
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: #1f3864"
            >十一、<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: #1f3864">其他</span></strong>
      </p>
      <p>&nbsp;</p>
      <p>
        本平台可能不时提供各种链接，最终可以跳转或指向非为武田中国所持有或控制的第三方网站或应用程序。本隐私政策不适用于此等网站或应用程序。若您选择跳转及使用此等网站或应用程序，请务必查看您所登入的网站或应用程序的隐私政策或隐私声明，谨慎选择是否同意并继续。本隐私政策不能引伸或适用于与本平台连结或相联的任何其他第三方网站或者平台。
      </p>
      <p>
        我们提醒您，一旦您离开本平台，浏览或使用其他网站、服务及内容资源，本平台即没有能力及义务保护您在本平台之外的网站或应用程序提交的任何个人信息，无论您登录或浏览上述网站或应用程序是否基于本平台中所包含的链接或引导，本平台对此不承担任何法律责任。
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: #1f3864"
            >十二、<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: #1f3864">如何联系我们</span></strong>
      </p>
      <p>&nbsp;</p>
      <p>
        如需更多关于武田隐私保护的政策，请访问：https://www.takeda.com/privacy-notice/
      </p>
      <p>&nbsp;</p>
      <p>
        如涉及隐私问题，可以联系
        <a href="mailto:PrivacyOffice@takeda.com" style="color: #0000ee"
          >PrivacyOffice@takeda.com</a
        >
      </p>
      <p>&nbsp;</p>
      <p class="MsoListParagraph" style="">
        <strong
          ><span style="color: #1f3864"
            >十三、<span style="font: 9px 'Times New Roman'"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ></strong
        ><strong><span style="color: #1f3864">定义与名词解释</span></strong>
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>本平台</strong
        >：由武田中国享有所有权和运营的账号为gh_2d053a85aa0c的微信公众号，该等微信公众号名称为“吾医空间”。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>武田中国、我们</strong
        >：直接或委托第三方提供本平台和相关服务的法律实体，包括武田（中国）投资有限公司、武田（中国）国际贸易有限公司、武田药品（中国）有限公司、天津武田药品有限公司一家或多家。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>关联公司</strong
        >：与武田中国存在关联关系的法律实体。“关联关系”是指对于任何主体（包括个人、公司、合伙企业、组织或其他任何实体）而言，即其直接或间接控制的主体，或直接或间接控制其的主体，或直接或间接与其受同一主体控制的主体。前述“控制”指，通过持有表决权、合约或其他方式，直接或间接地拥有对相关主体的管理和决策作出指示或责成他人作出指示的权力或事实上构成实际控制的其他关系。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>中国</strong
        >：指中华人民共和国，为本隐私政策之目的，不包括香港特别行政区、澳门特别行政区和台湾地区。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>个人信息</strong
        >：以电子或者其他方式记录的与已识别或可识别的自然人有关的各种信息，不包括匿名化处理后的信息。如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>去标识化</strong
        >：指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>匿名化</strong
        >：指个人信息经过处理无法识别特定自然人且不能复原的过程。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>敏感个人信息</strong
        >：敏感个人信息是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>IP地址</strong
        >：每台上网的设备都会指定一个编号，称为互联网协议(IP)地址。这些编号通常都是根据地理区域指定的。IP地址通常可用于识别设备连接至互联网时所在的位置。
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>OPENID</strong
        >：OPENID是微信用户在注册公众号后的唯一独立加密用户身份标识，此处OPENID是指本平台用户注册后的唯一加密用户身份标识。
      </p>
      <p>​<br /></p>
    </div>

    <div
      v-if="!outSource"
      style="text-align: center; margin: 10px 0 30px; padding-bottom: 50px"
    >
      <button @click="$router.history.go(-1)" class="redButton">返回</button>
    </div>
  </div>
</template>

<script>
import agreeBookTable from "../../assets/agreeBook-table.png";
export default {
  name: "login",
  data() {
    return {
      outSource: this.$route.query.outSource,
    };
  },
  created() {
    // document.title = '吾医空间'
  },
  mounted() {
    console.log(process.env.config.seviceUrl, "process.env.config.seviceUrl");
    if (process.env.config.seviceUrl.indexOf("wechatweb.takeda.com.cn") > -1) {
      document.title = "吾医空间";
    } else {
      document.title = "吾医空间测试号";
    }
  },
  methods: {},
};
</script>

<style scoped>
#login {
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: auto;
  background-color: #fff;
}
.all {
  width: 90%;
  margin-left: 5%;
}
.header {
  font-size: 20px;
  text-align: center;
  margin-bottom: 8px;
  font-weight: bold;
}
.container {
  text-align: justify;
  font-size: 14px;
}
.container .indent1 {
  text-indent: 0;
}
.container .indent1-1 {
  text-indent: 12px;
}
.container .indent1-1-1 {
  text-indent: 24px;
}
p.title {
  text-indent: 0em;
  font-size: 16px;
  font-weight: bold;
  color: #001866;
}
p.indent {
  text-indent: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/agreeBook.vue